/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IconButton,
  Tooltip,
  Avatar,
  FormControl,
  FormControlLabel,
  Switch,
  FormGroup,
} from "@material-ui/core";
import VerMas from "./VerMas";
import { Link } from "react-router-dom";
import ROUTES from "../../../constants/routes";
import { useDispatch } from "react-redux";
import { PUT_ADVISER_CODE } from "../../../constants/codes";
import { ModifyAdviser } from "../../../redux/actions";
import { Resource } from "ghost-stories/dist/unions/Resource";
import { FIX_URL } from "ghost-stories/dist/constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const { adviser } = props;
  const dispatch = useDispatch();
  const cod = "?code=" + PUT_ADVISER_CODE;

  const onChangeState = useCallback(
    (event) => {
      event.preventDefault();
      const valor = () => {
        if (adviser.AdviserState === "S") {
          return "N";
        }
        return "S";
      };
      const updateState = {
        ...adviser,
        AdviserState: valor(),
      };
      dispatch(
        ModifyAdviser(
          Resource.Query({
            [FIX_URL]: adviser.AdviserID + cod,
            ...updateState,
          })
        )
      );
    },
    [dispatch, adviser, cod]
  );

  const state = () => {
    if (adviser.AdviserState === "S") {
      return true;
    }
    return false;
  };
  return (
    <tr key={adviser.AdviserID}>
      <td className="text-left">
        <div className="d-flex align-items-center">
          <Avatar alt="Avatar" src={adviser.AdviserPhotoURL} className="mr-2" />
          <div>
            <a
              onClick={(e) => e.preventDefault()}
              className="font-weight-bold text-black"
              title={adviser.AdviserName}
            >
              {adviser.AdviserName} {adviser.AdviserLastname}
            </a>
          </div>
        </div>
      </td>
      <td className="text-left">{adviser.AdviserNumber}</td>
      <td className="text-left">{adviser.AdviserMail}</td>
      <td>
        <FormControl component="fieldset">
          <FormGroup aria-label="position" row>
            <FormControlLabel
              value="publico"
              control={
                <Switch
                  size="small"
                  color="secondary"
                  checked={state()}
                  onChange={onChangeState}
                  name="checkedA"
                />
              }
              label="Activo"
              labelPlacement="end"
            />
          </FormGroup>
        </FormControl>
      </td>
      <td>
        <Tooltip arrow title="Editar">
          <IconButton
            size="small"
            variant="outlined"
            color="secondary"
            component={Link}
            to={`${ROUTES.ASESORES_EDITAR.replace(":id", adviser.AdviserID)}`}
          >
            <FontAwesomeIcon icon={["fa", "edit"]} />
          </IconButton>
        </Tooltip>
      </td>
      <td className="text-center">
        <VerMas adviser={adviser} />
      </td>
    </tr>
  );
};
